// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"CustomTooltip_tooltip__tKFH6"};